import React from 'react'
import Image from '../atoms/Image'
import Headline from '../atoms/Headline'
import Richtext from '../atoms/Richtext'
import Link from '../atoms/Link'

import { useTranslation } from 'react-i18next'
import SbEditable from 'storyblok-react'

const InspirationBlock = ({ block }) => {
  const { t } = useTranslation()
  return (
    <SbEditable content={block}>
      <section className="inspiration-block">
        <div className="inspiration-block-img-container">
          <div className="inspiration-block-img-content">
            <Image
              data-rellax-center={true}
              data-rellax-speed={-2}
              className="inspiration-block-img"
              image={block.image}
              alt={block.alt}
            />
          </div>
        </div>

        <div className="inspiration-block-container">
          <div
            className={`inspiration-block-content-slider ${
              block.text?.length > 0
                ? ''
                : 'inspiration-block-content-slider-small'
            }`}
          >
            <Headline
              kicker={block.kicker}
              headline={block.headline}
              subheadline={block.subheadline}
            />
            <div>
              {block.text?.length > 0 && <Richtext text={block.text} />}
              {block.product_list_headline?.length > 0 &&
                block.product_list_headline}
              {block.product_list?.length > 0 && (
                <ul>
                  {block.product_list.map((item, index) => (
                    <li key={index}>
                      <Link link={item.link}>{item.link_text}</Link>
                    </li>
                  ))}
                </ul>
              )}
              {block.style_headline?.length > 0 && `${block.style_headline}`}
              <Link link={block.link}>{block.style_link_text}</Link>
              <Link link={block.image} download>
                {t('download_image')}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default InspirationBlock
